import { render, staticRenderFns } from "./TimeSlotsItem.vue?vue&type=template&id=6d425584"
import script from "./TimeSlotsItem.vue?vue&type=script&lang=js"
export * from "./TimeSlotsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports